/*
 * @Description:
 * @Date: 2025-05-27 16:20:36
 */
import { storeToRefs } from 'pinia';
import appStore from '@/store';

export const checkPermission = name => {
  const { resource } = storeToRefs(appStore.useResourceStoreSetup);
  return resource.value?.some(item => item.name === name);
};
